import { create } from 'zustand'

interface BannerState {
  visible: boolean
  show: () => void
  hide: () => void
}

export const useServerProvisioningBanner = create<BannerState>((set) => ({
  visible: false,
  show: () => set({ visible: true }),
  hide: () => set({ visible: false }),
}))
